import { FC } from 'react';

import { IconProps } from './types';

export const ChartIcon: FC<IconProps> = ({ size, width = 20, height = 20, color = '#06519E' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 20 20"
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M1 0a1 1 0 0 1 1 1v17h17a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1Zm15 6a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Zm-5-4a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Zm-5 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z"
		/>
	</svg>
);
